// extracted by mini-css-extract-plugin
export var button = "_lh-0";
export var donut = "_lh-1";
export var donutFill = "_lh-3";
export var donutTrack = "_lh-2";